export function toDateKey(value) {
  if (!value) return '';

  // Native <input type="date" /> returns YYYY-MM-DD already.
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';

  // Use UTC getters: API date-only values are UTC midnight, so local getters
  // shifted the key back a day in timezones behind UTC (broke same-day dedup).
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isSameDayKey(a, b) {
  const ak = toDateKey(a);
  const bk = toDateKey(b);
  return !!ak && ak === bk;
}

